import React, { useEffect, useState } from "react";
import './styles.css'
import { useNavigate, useLocation } from 'react-router-dom';
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import { isLoggedInUserBusiness, isLoggedInUserEmployee, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import { useSelector } from 'react-redux'
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";

const SuppliesMenu = props => {
    let navigate = useNavigate();
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.SUPPLIES.VIEW_MERCHANT) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.SUPPLIES, PERMISSION_SUB_TYPE.SUPPLIES.VIEW_MERCHANT, employeeSelectedBusiness, employeeSelectedLocation)
        } else if (pType === PERMISSION_SUB_TYPE.SUPPLIES.ADD_CATEGORY) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.SUPPLIES, PERMISSION_SUB_TYPE.SUPPLIES.VIEW_CATEGORIES, employeeSelectedBusiness, employeeSelectedLocation)
        } else if (pType === PERMISSION_SUB_TYPE.SUPPLIES.VIEW_ITEM) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.SUPPLIES, PERMISSION_SUB_TYPE.SUPPLIES.VIEW_ITEM, employeeSelectedBusiness, employeeSelectedLocation)
        }

    }

    const MENU_OPTIONS = [
        ...(isPermissionAllowed(PERMISSION_SUB_TYPE.SUPPLIES.VIEW_MERCHANT) ? [{ key: 'MERCHANTS', value: removeSpecialCharAndChangeToPascal('MERCHANTS') }] : []),
        ...(isPermissionAllowed(PERMISSION_SUB_TYPE.SUPPLIES.ADD_CATEGORY) ? [{ key: 'MANAGE_CATEGORIES', value: removeSpecialCharAndChangeToPascal('MANAGE_CATEGORIES') }] : []),
        ...(isPermissionAllowed(PERMISSION_SUB_TYPE.SUPPLIES.VIEW_ITEM) ? [{ key: 'ITEMS', value: removeSpecialCharAndChangeToPascal('ITEMS') }] : []),
    ]

    const handleOptionClick = item => {
        switch (item.key) {
            case 'MERCHANTS':
                navigate(ROUTES.supplies.merchant.list)
                break
            case 'MANAGE_CATEGORIES':
                navigate(ROUTES.supplies.category.list)
                break
            case 'ITEMS':
                navigate(ROUTES.supplies.item.catList)
                break
            default:
                break
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Select Option' />
                <div className="pms-option-list-container">
                    {MENU_OPTIONS.map(item => (<div className="pms-ol-item-container" onClick={() => { handleOptionClick(item) }}>
                        <h5 className="pms-oli-label">{item.value}</h5>
                        <div className="pms-oli-img-container">
                            <img src={require('../../../assets/ic_right_icon.png')} className="img" alt="img" />
                        </div>
                    </div>))}
                </div>
            </CommonScreenContent>
        </>
    )
}

export default SuppliesMenu